import React from 'react';
import Moment from '../../../components/utils/Moment';

export default class AllActivity extends React.Component {

  render() {
    const { activities, onCommentClick } = this.props;

    return (
      <div  className="chat-body no-padding profile-message">
        <ul>
          {activities && activities.map((activity, idx) => (
            <div key={idx} >

              {activity.type === "E" && (
                <div>
                  <div className="timeline-seperator text-center"> <span><Moment
                    date={activity.date}
                    format="h:mmA MMMM Do, YYYY"
                  /></span>
                  </div>
                  <div className="chat-body no-padding profile-message">
                    <ul>
                      <li className="message">
                        <img src="assets/img/avatars/appointment.png" className="online" alt="user" />
                        <span className="message-text">
                          <a href="" className="username">Appointment</a>
                          {activity.source.visitReason} </span>
                        <ul className="list-inline font-xs"><li><a className="text-primary"> </a></li><li><a className="text-danger"> </a></li></ul>
                      </li>
                    </ul>
                  </div>
                </div>
              )}

              {activity.type === "C" && (
                <div>
                  <div className="timeline-seperator text-center"> <span><Moment
                    date={activity.date}
                    format="h:mmA MMMM Do, YYYY"
                  /></span>
                  </div>
                  <div className="chat-body no-padding profile-message">
                    <ul>
                      {activity.source.parentId === null && (
                        <li className="message">
                          <img src="assets/img/avatars/sunny.png" className="online" alt="sunny" />
                          <span className="message-text"> <a href="" className="username">{activity.source.username} </a>
                            {(activity.source.comment)} </span>
                          <ul className="list-inline font-xs padding-top-10"><li><a className="text-primary" onClick={onCommentClick} data-comment={activity.source.id}>Go to comment</a></li><li><a className="text-danger"> </a></li></ul>
                        </li>
                      )}
                      {activity.source.parentId !== null && (
                        <li className="message">
                          <img src="assets/img/avatars/sunny.png" className="online" alt="user" />
                          <span className="message-text"> <a href="" className="username">{activity.source.username} </a>
                            {(activity.source.comment)}</span>
                            <ul className="list-inline font-xs padding-top-10"><li><a className="text-primary" onClick={onCommentClick} data-comment={activity.source.id}>Go to comment</a></li><li><a className="text-danger"> </a></li></ul>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              )}

              {activity.type === "RC" && (
                <div>
                  <div className="timeline-seperator text-center"> <span><Moment
                    date={activity.date}
                    format="h:mmA MMMM Do, YYYY"
                  /></span>
                  </div>
                  <div className="chat-body no-padding profile-message">
                    <ul>
                      <li className="message">
                        <img src="assets/img/avatars/appointment.png" className="online" alt="user" />
                        <span className="message-text"><a href="" className="username">Rx Claim </a>
                          Claims Data Feed </span>
                        <ul className="list-inline font-xs">
                          <li>
                            <div className="table table-responsive">
                              <table className="table table-bordered">
                                <thead>
                                  <tr>
                                    <th>Name</th>
                                    <th>Plan Paid Amount</th>
                                    <th>Fill Date</th>
                                    <th>Days Supply</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>{activity.source.drugName}</td>
                                    <td>{activity.source.planPaidAmount}</td>
                                    <td><Moment
                                      date={activity.source.filledAt}
                                      format="MM/DD/YYYY"
                                    /></td>
                                    <td>{activity.source.daysSupply}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
              )}

              {activity.type === "MC" && (
                <div>
                  <div className="timeline-seperator text-center"> <span><Moment
                    date={activity.date}
                    format="h:mmA MMMM Do, YYYY"
                  /></span>
                  </div>
                  <div className="chat-body no-padding profile-message">
                    <ul>
                      <li className="message">
                        <img src="assets/img/avatars/appointment.png" className="online" alt="user" />
                        <span className="message-text"> <a href="" className="username">Medical Claim </a>
                          Claims Data Feed </span>
                        <ul className="list-inline font-xs">
                          <li>
                            <div className="table table-responsive">
                              <table className="table table-bordered">
                                <thead>
                                  <tr>
                                    <th>Date of Service</th>
                                    <th>Place of Service</th>
                                    <th>Reason</th>
                                    <th>Procedure</th>
                                    <th>Carrier</th>
                                    <th>Service Category</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td><Moment
                                      date={activity.source.dateOfServiceStartDate}
                                      format="MM/DD/YYYY"
                                    /></td>
                                    <td>{activity.source.placeOfServiceGeneral}</td>
                                    <td>{activity.source.primaryEDC}</td>
                                    <td>{activity.source.procedureName}</td>
                                    <td>{activity.source.carrierName}</td>
                                    <td>{activity.source.serviceTypeSubcat}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
              )}

              {activity.type === "SP" && (
                <div>
                  <div className="chat-body no-padding profile-message">
                    {activity.source.unAssignmentType === null &&
                      (<ul>
                        <li className="message">
                        <img src="assets/img/sa-default.png" className="online" alt="user" />
                        <span className="message-text">
                          Special Program <strong>{activity.source.program.name}</strong> has been assigned by <strong>{activity.name}</strong> on <strong><Moment
                            date={activity.date}
                            format="MM/DD/YYYY HH:mm"
                          /></strong>.</span>
                          <ul className="list-inline font-xs"><li><a className="text-primary"> </a></li><li><a className="text-danger"> </a></li></ul>
                        </li>
                      </ul>)}
                    {activity.source.unAssignmentType !== null &&
                      (<ul>
                        <li className="message">
                          <img src="assets/img/sa-default.png" className="online" alt="user" />
                        <span className="message-text">
                          Special Program <strong>{activity.source.program.name}</strong> has been unassigned by <strong>{activity.name}</strong> on <strong><Moment
                            date={activity.date}
                            format="MM/DD/YYYY HH:mm"
                          /></strong>.</span>
                          <ul className="list-inline font-xs"><li><a className="text-primary"> </a></li><li><a className="text-danger"> </a></li></ul>
                        </li>
                      </ul>)}
                  </div>
                </div>
              )}
              
            </div>
          ))}
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/management/components/AllActivity.js